(() => {
 const initialize = (root) => {
  if (root.dataset.nav04Ready) return;
  root.dataset.nav04Ready = 'true';
  const header = root.closest('#header-component');
  const panels = [...root.querySelectorAll('[data-nav04-panel]')];
  const drawer = root.querySelector('[data-nav04-drawer]');
  const desktop = root.classList.contains('nav04--desktop');
  let closeTimer;
  const blocked = new Map();
  const visible = () => root.getClientRects().length > 0;
  const syncBackground = () => {
   if (!drawer) return;
   const targets = [document.querySelector('#MainContent'), document.querySelector('footer'), ...header.querySelectorAll('.header-logo, search-button, header-actions, .dropdown-localization')].filter(Boolean);
   if (drawer.open) {
    targets.forEach((element) => { if (!blocked.has(element)) blocked.set(element, element.inert); element.inert = true; });
   } else {
    blocked.forEach((value, element) => { element.inert = value; });
    blocked.clear();
   }
  };
  const update = () => {
   if (!header) return;
   header.style.setProperty('--nav04-bottom', `${Math.max(0, header.getBoundingClientRect().bottom)}px`);
   const isOpen = [...header.querySelectorAll('[data-nav04-panel], [data-nav04-drawer]')].some((panel) => panel.open);
   header.toggleAttribute('data-nav04-open', isOpen);
   header.setAttribute('data-menu-open-04', String(isOpen));
   syncBackground();
   header.dispatchEvent(new CustomEvent('nav04:change', { bubbles: true, detail: { open: isOpen } }));
  };
  const close = () => { panels.forEach((panel) => { panel.open = false; }); update(); };
  const open = (panel) => {
   clearTimeout(closeTimer);
   panels.forEach((other) => { if (other !== panel) other.open = false; });
   panel.open = true;
   update();
  };
  panels.forEach((panel) => {
   panel.addEventListener('toggle', () => {
    panel.querySelector(':scope > summary').setAttribute('aria-expanded', String(panel.open));
    if (panel.open) panels.forEach((other) => { if (other !== panel) other.open = false; });
    update();
   });
   panel.querySelector(':scope > summary').setAttribute('aria-expanded', String(panel.open));
   if (desktop) {
    panel.addEventListener('pointerenter', (event) => { if (event.pointerType === 'mouse') open(panel); });
    panel.querySelector(':scope > summary').addEventListener('keydown', (event) => { if (event.key === 'ArrowDown') { event.preventDefault(); open(panel); panel.querySelector('a')?.focus(); } });
    panel.addEventListener('pointerleave', (event) => {
     if (event.pointerType === 'mouse' && !panel.contains(document.activeElement)) closeTimer = setTimeout(close, 150);
    });
    panel.addEventListener('focusout', () => { requestAnimationFrame(() => { if (!panel.contains(document.activeElement) && !panel.matches(':hover')) close(); }); });
   }
  });
  if (drawer) {
   drawer.querySelector(':scope > summary').setAttribute('aria-expanded', String(drawer.open));
   drawer.addEventListener('toggle', () => {
    drawer.querySelector(':scope > summary').setAttribute('aria-expanded', String(drawer.open));
    if (!drawer.open) panels.forEach((panel) => { panel.open = false; });
    update();
    if (drawer.open) drawer.querySelector('.nav04__navigation summary, .nav04__navigation a')?.focus();
   });
   drawer.addEventListener('keydown', (event) => {
    if (event.key !== 'Tab' || !drawer.open) return;
    const controls = [...drawer.querySelectorAll('a, summary, button, input')].filter((element) => element.getClientRects().length);
    const first = controls[0]; const last = controls[controls.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
   });
  }
  document.addEventListener('keydown', (event) => {
   if (event.key !== 'Escape' || !visible()) return;
   const active = panels.find((panel) => panel.open && panel.contains(document.activeElement)) || panels.find((panel) => panel.open);
   if (!active && !drawer?.open) return;
   if (active) { active.open = false; active.querySelector('summary').focus(); }
   else if (drawer?.open) { drawer.open = false; drawer.querySelector('summary').focus(); }
   else close();
   update();
  });
  document.addEventListener('pointerdown', (event) => {
   if (!root.contains(event.target)) { close(); if (drawer) drawer.open = false; update(); }
  });
  window.addEventListener('resize', () => {
   if (desktop && window.innerWidth < 990) close();
   if (drawer && window.innerWidth >= 990) { drawer.open = false; close(); }
   update();
  });
  update();
 };
 const initializeAll = () => document.querySelectorAll('[data-nav04]').forEach(initialize);
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
 else initializeAll();
 document.addEventListener('shopify:section:load', initializeAll);
})();

